import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";

class NotFound extends Component {
  goHomeClick = () => {
    this.props.history.push("/");
  };

  render() {
    return (
      <Fragment>
        <div className="text-error">
          <h1>Страница не найдена</h1>
        </div>

        <div className="goHome" onClick={this.goHomeClick}>
          Вернуться на главную
        </div>
      </Fragment>
    );
  }
}

export default withRouter(NotFound);



// WEBPACK FOOTER //
// ./src/containers/NotFound.jsx